/* tslint:disable */
/* eslint-disable */
/**
 * BonusX
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { ServiceRequestFeedback } from '../models';
/**
 * ServiceRequestFeedbackApi - axios parameter creator
 * @export
 */
export const ServiceRequestFeedbackApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Submit a feedback about a caf member.
         * @param {ServiceRequestFeedback} [serviceRequestFeedback] A JSON object containing service request feedback information
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createServiceRequestFeedback: async (serviceRequestFeedback?: ServiceRequestFeedback, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/service-request-feedback/submit`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication cookieAuth required

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(serviceRequestFeedback, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get a feedback about a caf member.
         * @param {number} serviceRequestId Numeric ID of the servire request
         * @param {number} cafMemberId Numeric ID of the Operator id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findOneServiceRequestFeedback: async (serviceRequestId: number, cafMemberId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'serviceRequestId' is not null or undefined
            assertParamExists('findOneServiceRequestFeedback', 'serviceRequestId', serviceRequestId)
            // verify required parameter 'cafMemberId' is not null or undefined
            assertParamExists('findOneServiceRequestFeedback', 'cafMemberId', cafMemberId)
            const localVarPath = `/service-request-feedback/findOne`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication cookieAuth required

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (serviceRequestId !== undefined) {
                localVarQueryParameter['serviceRequestId'] = serviceRequestId;
            }

            if (cafMemberId !== undefined) {
                localVarQueryParameter['cafMemberId'] = cafMemberId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ServiceRequestFeedbackApi - functional programming interface
 * @export
 */
export const ServiceRequestFeedbackApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ServiceRequestFeedbackApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Submit a feedback about a caf member.
         * @param {ServiceRequestFeedback} [serviceRequestFeedback] A JSON object containing service request feedback information
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createServiceRequestFeedback(serviceRequestFeedback?: ServiceRequestFeedback, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createServiceRequestFeedback(serviceRequestFeedback, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ServiceRequestFeedbackApi.createServiceRequestFeedback']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get a feedback about a caf member.
         * @param {number} serviceRequestId Numeric ID of the servire request
         * @param {number} cafMemberId Numeric ID of the Operator id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findOneServiceRequestFeedback(serviceRequestId: number, cafMemberId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ServiceRequestFeedback>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findOneServiceRequestFeedback(serviceRequestId, cafMemberId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ServiceRequestFeedbackApi.findOneServiceRequestFeedback']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ServiceRequestFeedbackApi - factory interface
 * @export
 */
export const ServiceRequestFeedbackApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ServiceRequestFeedbackApiFp(configuration)
    return {
        /**
         * 
         * @summary Submit a feedback about a caf member.
         * @param {ServiceRequestFeedback} [serviceRequestFeedback] A JSON object containing service request feedback information
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createServiceRequestFeedback(serviceRequestFeedback?: ServiceRequestFeedback, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.createServiceRequestFeedback(serviceRequestFeedback, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get a feedback about a caf member.
         * @param {number} serviceRequestId Numeric ID of the servire request
         * @param {number} cafMemberId Numeric ID of the Operator id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findOneServiceRequestFeedback(serviceRequestId: number, cafMemberId: number, options?: RawAxiosRequestConfig): AxiosPromise<ServiceRequestFeedback> {
            return localVarFp.findOneServiceRequestFeedback(serviceRequestId, cafMemberId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ServiceRequestFeedbackApi - interface
 * @export
 * @interface ServiceRequestFeedbackApi
 */
export interface ServiceRequestFeedbackApiInterface {
    /**
     * 
     * @summary Submit a feedback about a caf member.
     * @param {ServiceRequestFeedback} [serviceRequestFeedback] A JSON object containing service request feedback information
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServiceRequestFeedbackApiInterface
     */
    createServiceRequestFeedback(serviceRequestFeedback?: ServiceRequestFeedback, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * 
     * @summary Get a feedback about a caf member.
     * @param {number} serviceRequestId Numeric ID of the servire request
     * @param {number} cafMemberId Numeric ID of the Operator id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServiceRequestFeedbackApiInterface
     */
    findOneServiceRequestFeedback(serviceRequestId: number, cafMemberId: number, options?: RawAxiosRequestConfig): AxiosPromise<ServiceRequestFeedback>;

}

/**
 * ServiceRequestFeedbackApi - object-oriented interface
 * @export
 * @class ServiceRequestFeedbackApi
 * @extends {BaseAPI}
 */
export class ServiceRequestFeedbackApi extends BaseAPI implements ServiceRequestFeedbackApiInterface {
    /**
     * 
     * @summary Submit a feedback about a caf member.
     * @param {ServiceRequestFeedback} [serviceRequestFeedback] A JSON object containing service request feedback information
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServiceRequestFeedbackApi
     */
    public createServiceRequestFeedback(serviceRequestFeedback?: ServiceRequestFeedback, options?: RawAxiosRequestConfig) {
        return ServiceRequestFeedbackApiFp(this.configuration).createServiceRequestFeedback(serviceRequestFeedback, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get a feedback about a caf member.
     * @param {number} serviceRequestId Numeric ID of the servire request
     * @param {number} cafMemberId Numeric ID of the Operator id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServiceRequestFeedbackApi
     */
    public findOneServiceRequestFeedback(serviceRequestId: number, cafMemberId: number, options?: RawAxiosRequestConfig) {
        return ServiceRequestFeedbackApiFp(this.configuration).findOneServiceRequestFeedback(serviceRequestId, cafMemberId, options).then((request) => request(this.axios, this.basePath));
    }
}

